import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";
import {BookOfShadowsParsedGameData} from "../../server/data/BookOfShadowsParsedGameData";
import {BookOfShadowsFreeSpinOutroView} from "./BookOfShadowsFreeSpinOutroView";
import {BookOfShadows} from "../../BookOfShadows";
import {BookOfShadowsGameModuleConfig} from "../../BookOfShadowsGameModuleConfig";
import {SoundManager} from "../../sound/SoundManager";
import {BookOfShadowsSoundConfig} from "../../BookOfShadowsSoundConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BookOfShadowsReelController} from "../../reel/BookOfShadowsReelController";
import {BookOfShadowsGameMode} from "../../gameMode/BookOfShadowsGameMode";
import {TweenLite} from "gsap";

export class BookOfShadowsFreeSpinOutroTransitionController extends GameModeTransitionController {
    private _view: BookOfShadowsFreeSpinOutroView;

    /**
     * @constructs
     * @param fromMode
     * @param toMode
     */
    constructor(fromMode: string, toMode: string) {
        super(fromMode, toMode);

        this._view = new BookOfShadowsFreeSpinOutroView(StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.FREE_SPIN.name), () => this.finish());
    }

    /**
     * @inheritDoc
     * @override => To call the finish once the view is done.
     */
    public start(): void {
        TweenLite.delayedCall(BookOfShadowsGameConfig.instance.ABORT_DELAY, () => this.startAfterDelay());
    }

    /**
     * @inheritDoc
     * @param data
     */
    protected onGameDataParsed(data: BookOfShadowsParsedGameData): void {
        super.onGameDataParsed(data);

        this._view.prepare(data);
    }

    // we don't want to hide/show keypad for this transition.
    protected hideKeypad(): void {
    }

    // we don't want to hide/show keypad for this transition.
    protected showKeypad(): void {
    }

    /**
     * @inheritDoc
     */
    protected finish(): void {
        this._view.cleanUp();

        BookOfShadowsGameModuleConfig.reelBackgroundView.resetAllSymsToNormal();

        BookOfShadowsGameModuleConfig.fireParticles.togglePlay(false);
        BookOfShadowsGameModuleConfig.background.toggleFSFrame(false);
        BookOfShadowsGameModuleConfig.reelBackgroundView.toggleFsMode(false);

        // #108
        for (let i: number = 0; i < BookOfShadowsGameConfig.instance.REELS_NUM; i++) {
            (Reels.getReel(i) as BookOfShadowsReelController).exitFS();
        }

        SoundManager.fadeAmbienceLoop(0, 200);
        SoundManager.playAmbientLoop(BookOfShadowsSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 200);

        if (this._serverData.nextMode === BookOfShadowsGameMode.NORMAL) {
            BookOfShadowsGameModuleConfig.inactiveRowController.updateVisibleRows();
            BookOfShadowsGameModuleConfig.gameTutorial.exitFS();
            BookOfShadowsGameModuleConfig.reelLockController.exitedFS();

            // #155
            BookOfShadows.setBoostedBet();
        }

        super.finish();
    }

    /**
     * @description To start after the abort is done.
     */
    private startAfterDelay(): void {
        // #233
        BookOfShadows.keypad.setZeroBetSpinCounter(-1);

        BookOfShadowsGameConfig.instance.ABORT_DELAY = 0;

        this.prepareToEnterMode();

        // #331
        if (!BookOfShadowsGameModuleConfig.featurePrice.isWinBelowStake()) {
            SoundManager.playFSEnd();
        }
        this._view.startAnimation();
    }
}